import { useCallback, useEffect, useState } from 'react';
import { getCustomFields, updateCustomFieldOrder } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';
import { getModuleNameFromActiveIndex } from '../components/CustomFieldHelper';
const defaultCustomField = { case: [], contact: [], companies: [] };

export const useCustomFieldsData = (effectiveStatus, activeIndex, userDetails) => {
  const [customFields, setCustomFields] = useState(defaultCustomField);
  const [currentUserPageVal, setCurrentUserPageVal] = useState(10);

  const loadCustomFields = useCallback(
    (module = '') => {
      totalCountEvent('custom-field')
        .then((response) => {
          getCustomFields(module, response.data, '', '', effectiveStatus)
            .then((response) => {
              let sortedData = { case: [], contact: [], companies: [] };
              response?.data?.['custom-field'].forEach((item) => {
                if (item.module === 'case') sortedData.case.push(item);
                else if (item.module === 'contact') sortedData.contact.push(item);
                else if (item.module === 'companies') sortedData.companies.push(item);
              });
              setCustomFields(sortedData);
            })
            .catch();
        })
        .catch(() => {});
    },
    [effectiveStatus]
  );

  const reorderField = useCallback((e) => {
    if (e?.value?.length > 0) {
      setCustomFields((preVal) => ({
        ...preVal,
        [e?.value?.[0]?.module]: e?.value,
      }));
      updateCustomFieldOrder({ item_list: e?.value?.map((item, i) => ({ pk: item?.pk, sk: item?.sk, position: i + 1 })) }).catch(() => {});
    }
  }, []);

  const handlePageChangePreference = useCallback(
    (handlePageNumberInPagination) => {
      const currentModule = getModuleNameFromActiveIndex(activeIndex);
      handlePageNumberInPagination(userDetails, 'settings', 'custom_fields', currentModule, currentUserPageVal);
    },
    [activeIndex, currentUserPageVal, userDetails]
  );

  useEffect(() => {
    loadCustomFields('');
  }, [loadCustomFields]);

  return {
    customFields,
    setCustomFields,
    currentUserPageVal,
    setCurrentUserPageVal,
    reorderField,
    loadCustomFields,
    handlePageChangePreference,
  };
};
